// extracted by mini-css-extract-plugin
module.exports = {"header":"campaignHero_header__oN1MF","heroContainer":"campaignHero_heroContainer__fV4XC","image":"campaignHero_image__mvTlE","hero":"campaignHero_hero__XmkGK"};